import { UserNotificationResponseDto } from 'src/app/shared/models/responses/user-notification.response';
import { ChatMessage } from './../../messages/models/chat-message';
import { AuthenticationService } from './../../auth/services/authentication.service';
import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { environment } from 'src/environments/environment';
import { from } from 'rxjs';
import { tap } from 'rxjs/operators';
import { UiStateStore } from '../store/ui-state-store.service';
import { AuthenticationResult } from '../models/authentication-result';

@Injectable({
  providedIn: 'root'
})
export class SignalrService {
  private user: AuthenticationResult;
  private hubConnection: signalR.HubConnection;
  private connectionUrl = `${environment.baseApiUrl}/appHub`;

  constructor(private uiState: UiStateStore
  ) {
    this.uiState._authenticationResult.subscribe(resp => {
      this.user = resp;
    });
  }

  connect = async () => {
    await this.startConnection();
    this.addListeners();
  };

  saveMessageToNotification = (chatMessage: ChatMessage) => {
    const request = {
      jobId: chatMessage.jobid,
      message: chatMessage.message,
      from: chatMessage.from === 'candidate' ? chatMessage.candidateid : chatMessage.employerid,
      to: chatMessage.from === 'candidate' ? chatMessage.employerid : chatMessage.candidateid,
    }
    // This invokes the server method named as "SendMessage" directly.
    const promise = this.hubConnection
      .invoke('SaveMessageToNotification', request)
      .then((data) => data)
      .catch((err) =>
        console.log('error while sending a message to hub: ' + err)
      );

    return from(promise);
  };

  notifyUsersViaHub = (request: any) => {
    // This invokes the server method named as "NotifyUsers" directly.
    const promise = this.hubConnection
      .invoke('NotifyUsers', request)
      .then((data) => data)
      .catch((err) =>
        console.log('error while sending a message to hub: ' + err)
      );

    return from(promise);
  };

  private getConnection(): signalR.HubConnection {
    // create connection with server side signalR hub
    return (
      new signalR.HubConnectionBuilder()
        .withUrl(this.connectionUrl,
          {
            skipNegotiation: true,
            transport: signalR.HttpTransportType.WebSockets
          }
        )
        //.withHubProtocol(new MessagePackHubProtocol())
        .configureLogging(signalR.LogLevel.Debug)
        .withAutomaticReconnect()
        .build()
    );
  }

  private async startConnection() {
    this.hubConnection = this.getConnection();
    try {
      await this.hubConnection.start();
    } catch (err) {
      console.log(err);
    }
  }

  private addListeners() {
    this.hubConnection.on(
      'ReceiveNotification',
      (notification: UserNotificationResponseDto) => {
        // receive message from server by calling this client method
        this.mapReceivedMessage(notification);
      }
    );

    // binding call back to when connection closes
    this.hubConnection.onclose(async () => {
      await this.startConnection();
    });
  }

  private mapReceivedMessage = (notification: UserNotificationResponseDto): void => {
    const shouldNotifyToCurrentUser = notification.notifyTo === this.user.accountId;

    if(shouldNotifyToCurrentUser) {
      this.uiState.setSuccess(notification.notificationText);
      this.uiState.setCurrentNotification(notification);
    }
  };
}
